<div class="flex-fill d-flex overflow-y-hidden">
  <div class="p-3 position-absolute">
      <div><p-button icon="fa-solid fa-list" [text]="true" severity="secondary" (onClick)="historyVisible = true"
                  pTooltip="Show chat history"/></div>
      <div><p-button icon="fa-regular fa-pen-to-square" [text]="true" severity="secondary" (onClick)="reset()"
                  pTooltip="New chat"/></div>
  </div>
  <div class="p-3 position-absolute" style="right: 0">
    <p-button *ngIf="chatType === chatTypeEnum.GENERIC" icon="pi pi-cog"  [rounded]="true" [text]="true" severity="secondary"
              (onClick)="settingsVisible = !settingsVisible" pTooltip="Settings"></p-button>
    <div *ngIf="chatType === chatTypeEnum.COMPANY && availableIndexes.length > 1" class="button-wrapper">
      <p-button icon="pi pi-cog" [rounded]="true" [text]="true" severity="secondary"  pTooltip="Settings" (onClick)="settingsVisible = !settingsVisible"></p-button>
    </div>
    <div *ngIf="chatType === chatTypeEnum.ASSISTANT" class="button-wrapper" >
      <p-button icon="pi pi-cog" [rounded]="true" [text]="true" severity="secondary" pTooltip="Settings" (onClick)="settingsVisible = !settingsVisible"></p-button>
    </div>
  </div>

  <app-history 
    [history]="history"
    [chatType]="chatType"
    [ngClass]="{'sidebar-w': historyVisible}"
    [reloadChatHistory$]="reloadChatHistory$"
    (onNewChat)="reset()"
    (onChatHistoryItemLoad)="loadChatHistoryItem($event)"
  ></app-history>

  <div class="flex-fill d-flex flex-column overflow-y-hidden">
      <div *ngIf="showWelcomeMessage" class="page-container">
        <div class="container">
          <h1 class="text-center">Start chatting</h1>
          <p class="text-center">
            {{description}}</p>
          <p class="text-center">
            We use our own separate <strong>GPT</strong> models, which run securely in Microsoft Azure. The application
            allows you to chat about topics and information up to classification level <strong>confidential.</strong></p>
          <p *ngIf="isAssistant()" class="text-center">
            Please upload your file(s) either using the toolbar below to attach them to a single prompt, or through the
            settings on the right side to attach them to the entire thread.
          </p>
        </div>

      </div>

      <div #messagesContainer class="overflow-y-auto flex-fill page-container">
        <app-chat-messages></app-chat-messages>
      </div>

      <div class="page-container mb-3 mt-3">
        <app-chat-input></app-chat-input>
      </div>
   </div>

  <p-sidebar #settingsSidebar id="settings" styleClass="chat-sidebar" [visible]="settingsVisible && chatType === chatTypeEnum.GENERIC" (visibleChange)="onSettingsVisibleEvent($event)" position="right"
              [modal]="false" [ngStyle]="{width: settingsVisible && chatType === chatTypeEnum.GENERIC ? '18.5%' : ''}">
    <ng-template pTemplate="header">
        <div class="flex-fill">
          <h4 class="text-center">Settings</h4>
        </div>
    </ng-template>
    <app-settings></app-settings>
  </p-sidebar>

  <p-sidebar #assistantSettingsSidebar id="assistantSettings" styleClass="chat-sidebar" [visible]="settingsVisible && chatType === chatTypeEnum.ASSISTANT" (visibleChange)="onSettingsVisibleEvent($event)" position="right"
              [modal]="false" [ngStyle]="{width: settingsVisible && chatType === chatTypeEnum.ASSISTANT ? '18.5%' : ''}">
    <ng-template pTemplate="header">
      <p-button icon="pi pi-info-circle" class="ms-0" [rounded]="true" [text]="true" severity="secondary" (onClick)="op.toggle($event)" />
      <div class="flex-fill">
        <h4 class="text-center">Thread files</h4>
      </div>
      <div>
        <p-overlayPanel #op>
          <p class="mt-0">
            Selected files are added to a context of the whole conversation (thread).
          </p>
          <div>
            <strong>Search files</strong>
          </div>
          <p class="mt-0">
            Supported file types: {{getAcceptedTypesFormatted(appConstants.ACCEPTED_FILE_FORMATS_FILES)}}
          </p>
          <div>
            <strong>Code interpreters</strong>
          </div>
          <p class="mt-0">
            Supported file types: {{getAcceptedTypesFormatted(appConstants.ACCEPTED_FILE_FORMATS_CODE_INTERPRETERS)}}
          </p>
          <p class="mt-0">
            Max. size of file: 200 MB, all files together: 512 MB (search files and code interpreters have its own limit). Max. number of files: 20.
          </p>
        </p-overlayPanel>
      </div>
    </ng-template>
    <app-assistant-settings></app-assistant-settings>
  </p-sidebar>

  <p-sidebar id="companyChatSettings" styleClass="chat-sidebar" position="right" [visible]="settingsVisible && chatType === chatTypeEnum.COMPANY" (visibleChange)="onSettingsVisibleEvent($event)"
              [modal]="false" [ngStyle]="{width: settingsVisible && chatType === chatTypeEnum.COMPANY ? '18.5%' : ''}">
    <ng-template pTemplate="header">
      <div class="flex-fill">
        <h4 class="text-center">Settings</h4>
      </div>
    </ng-template>
    <app-company-chat-settings [availableIndexes]="availableIndexes" (onNewChat)="reset()"></app-company-chat-settings>
  </p-sidebar>
</div>

<p-toast />
<p-confirmDialog />

